import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M7.5 27L4 23.5 7.5 20M8 7.5h12a8 8 0 110 16H4" fill="none" />
  </Icon>
);
